import { Montserrat, Anton, Fraunces, Space_Mono } from 'next/font/google';

export const anton = Anton({
  weight: '400',
  subsets: ['latin'],
  variable: '--font-anton',
});

export const montserrat = Montserrat({
  weight: ['400', '700'],
  subsets: ['latin'],
  variable: '--font-montserrat',
});

/** Joydrop Moments onboarding — variable Fraunces (opsz 9–144, wght 900 via CSS). */
export const fraunces = Fraunces({
  subsets: ['latin'],
  weight: 'variable',
  axes: ['opsz'],
  variable: '--font-fraunces',
});

export const spaceMono = Space_Mono({
  weight: '400',
  subsets: ['latin'],
  variable: '--font-space-mono',
});

export const fonts = {
  anton,
  montserrat,
  fraunces,
  spaceMono,
};
